/**
 * Reducer key for the private notes feature.
 */
export const REDUCER_KEY = 'features/notes';

/**
 * Prefix for localStorage keys that hold per-room private notes.
 */
export const NOTES_STORAGE_PREFIX = 'mh-conference-notes:';

/**
 * Endpoint message types for sharing notes with chosen participants.
 * Each is sent as a private message, so nobody else receives the content.
 */
export const NOTES_SHARE_MESSAGE = 'notes-share';
export const NOTES_UNSHARE_MESSAGE = 'notes-unshare';
export const NOTES_EDIT_MESSAGE = 'notes-edit';
export const NOTES_EDIT_RESULT_MESSAGE = 'notes-edit-result';

/**
 * Share audiences: picked participants, or everyone in the room including
 * people who join later.
 */
export const SHARE_AUDIENCE_SELECTED = 'selected';
export const SHARE_AUDIENCE_EVERYONE = 'everyone';

/**
 * Share permissions a recipient can hold.
 */
export const SHARE_PERMISSION_VIEW = 'view';
export const SHARE_PERMISSION_EDIT = 'edit';

/**
 * Verdicts an owner can return on a notes-edit request, plus the in-flight
 * state before a reply arrives.
 */
export const EDIT_RESULT_PENDING = 'pending';
export const EDIT_RESULT_ACCEPTED = 'accepted';
export const EDIT_RESULT_CONFLICT = 'conflict';
export const EDIT_RESULT_REJECTED = 'rejected';

/**
 * Local verdict used when a request never reaches the owner (send failure,
 * missing conference, or the owner already left).
 */
export const EDIT_RESULT_FAILED = 'failed';

/**
 * How long an edit request may stay unresolved — waiting for the owner's
 * verdict or for the authoritative share after an acceptance — before it is
 * treated as failed.
 */
export const EDIT_TIMEOUT_MS = 10000;

/**
 * Largest shareable notes JSON, in UTF-16 units. It travels as one XMPP stanza
 * and Prosody drops the connection on stanzas over its limit (256 KiB by
 * default); at up to 3 UTF-8 bytes per unit this stays under it.
 */
export const MAX_SHARED_NOTES_LENGTH = 80000;
